import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stack,
    Typography,
    Paper,
    Grid,
} from "@mui/material";
import { Business, Category, HomeOutlined, MapOutlined, Place } from "@mui/icons-material";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import * as wjGrid from "@grapecity/wijmo.react.grid";
import * as wjCore from "@grapecity/wijmo";
import "@grapecity/wijmo.styles/wijmo.css";
import CareUnitSelectionDialog from "./CareUnitSelectionDialog";
import {
    PeopleAltOutlined,
    EventSeatOutlined,
    PendingActionsOutlined,
    Groups2Outlined,
} from "@mui/icons-material";
import { getAgeAtYearEnd } from "qubCommon/helperMethods/genericMethods";


const CareUnitInfoTile = ({ label, value, color, icon }) => (
    <Box
        sx={{
            flex: "1 1 45%",
            bgcolor: "#fafafa",
            borderRadius: 2,
            p: 1.5,
            border: "1px solid #e0e0e0",
            display: "flex",
            alignItems: "center",
            gap: 1.2,
            boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
            transition: "all 0.2s ease",
            "&:hover": {
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                transform: "translateY(-2px)",
            },
        }}
    >
        <Box
            sx={{
                bgcolor: color,
                borderRadius: "10px",
                p: 0.8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 32,
                height: 32,
            }}
        >
            {icon}
        </Box>

        <Box>
            <Typography
                variant="body2"
                sx={{ fontWeight: 500, color: "#424242", lineHeight: 1 }}
            >
                {label}
            </Typography>

            <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "#212121", lineHeight: 1.2 }}
            >
                {value}
            </Typography>
        </Box>
    </Box>
);


const CareUnitSelection = ({ apartments = [], canChangeApartment = false, child }) => {
    const { watch, setValue } = useFormContext();
    const selected = watch("selectedInstitute");
    console.log()


    useEffect(() => {
        if (selected) {
            const selectedApartment = apartments.find(a => a.id === selected.id);
            if (selectedApartment) {
                setValue('selectedInstitute', selectedApartment);
            }

            setValue('selectedApartmentId', selected?.id || null);
        }
    }, [])

    const [openDialog, setOpenDialog] = useState(false);


    const formatCharacteristics = (cc) => {
        if (!cc || cc.length === 0) return "-";
        return cc.map((c) => `${c.gender} (${c.age})`).join(", ");
    };

    /** -------------------------------
     *  ACCORDION TITLE
     *  ------------------------------- */
    const AccordionTitle = () => (
        <Stack direction="row" gap={1} alignItems="center">
            <HomeOutlined color="primary" fontSize="small" />

            <Typography color="primary" sx={{ fontWeight: 900 }}>
                {canChangeApartment ? "ΕΠΙΛΟΓΗ ΜΠΠΦ" : "ΜΠΠΦ"}
            </Typography>

            {selected && (
                <Typography color="primary" sx={{ ml: 2 }}>
                    {selected?.name}
                </Typography>
            )}
        </Stack>
    );

    /** -------------------------------
     *  ACCORDION MAIN CONTENT
     *  ------------------------------- */
    const AccordionContent = () => (
        <Box>
            {!selected ? (
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Δεν έχει επιλεγεί μονάδα παιδικής προστασίας και φροντίδας.
                </Typography>
            ) : (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2, mb: 2 }}>
                    <CareUnitInfoTile
                        label="Τύπος Φορέα"
                        value={selected.type}
                        color="#E3F2FD"
                        icon={<Business sx={{ color: "#1E88E5" }} />}
                    />

                    <CareUnitInfoTile
                        label="Κατηγορία Φορέα"
                        value={selected.category}
                        color="#E8F5E9"
                        icon={<Category sx={{ color: "#43A047" }} />}
                    />

                    <CareUnitInfoTile
                        label="Περιφέρεια"
                        value={selected.region}
                        color="#FFF3E0"
                        icon={<MapOutlined sx={{ color: "#FB8C00" }} />}
                    />

                    <CareUnitInfoTile
                        label="Διεύθυνση"
                        value={typeof selected.address === 'object' ? selected.address.street + ' ' + selected.address.streetNumber + ', ' + selected.address.zip + selected.address.city : selected.address}
                        color="#F3E5F5"
                        icon={<Place sx={{ color: "#8E24AA" }} />}
                    />
                </Box>


            )}

            {canChangeApartment && <Button variant="contained" onClick={() => {
                setOpenDialog(true);
            }}>
                {selected ? "Αλλαγή ΜΠΠΦ" : "Επιλογή ΜΠΠΦ"}
            </Button>}

            {/* ========================================= */}
            {/* ===============   DIALOG   =============== */}
            {/* ========================================= */}

            <CareUnitSelectionDialog
                open={openDialog}
                childGender={child?.gender?.name}
                childAge={getAgeAtYearEnd(child?.dob)}
                apartments={apartments.map(a => a.childrenCharacteristics?.length > 0 ? { ...a, characteristics: formatCharacteristics(a.childrenCharacteristics) } : a)}
                onConfirm={(apt) => {
                    setValue("selectedInstitute", apt, { shouldDirty: true });
                    setValue("selectedApartmentId", apt.id, { shouldDirty: true });
                    setOpenDialog(false);
                }}
                onClose={() => setOpenDialog(false)}
            />

        </Box>
    );

    return (
        <CustomSimpleAccordion title={<AccordionTitle />} content={<AccordionContent />} />
    );
};

export default CareUnitSelection;
